module.exports = __webpack_public_path__ + "static/infernal_script-84280d829904d73e89bb93c1e05bfa4c.png";